import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import {
  KalturaClient,
  ConversionProfileListAction,
  KalturaConversionProfileFilter,
  KalturaConversionProfileType,
  KalturaFilterPager,
  KalturaConversionProfileListResponse,
  KalturaConversionProfile,
} from 'kaltura-ngx-client';

import { AppEventsService } from 'app-shared/kmc-shared';
import { cancelOnDestroy } from '@kaltura-ng/kaltura-common';
import { TranscodingProfilesUpdatedEvent } from 'app-shared/kmc-shared/events';

@Injectable()
export class TranscodingProfileManagement implements OnDestroy {
  private _transcodingProfileCache$;

  constructor(private _serverClient: KalturaClient, _appEvents: AppEventsService) {
    _appEvents
      .event(TranscodingProfilesUpdatedEvent)
      .pipe(cancelOnDestroy(this))
      .subscribe(() => {
        this._clearCache();
      });
  }

  ngOnDestroy() {}

  private _clearCache(): void {
    this._transcodingProfileCache$ = null;
  }

  private _loadTranscodingProfiles(): Observable<KalturaConversionProfile[]> {
    return this._serverClient
      .request(
        new ConversionProfileListAction({
          filter: new KalturaConversionProfileFilter({ typeEqual: KalturaConversionProfileType.media }),
          pager: new KalturaFilterPager({ pageSize: 500 }),
        }),
      )
      .map((res: KalturaConversionProfileListResponse) => res.objects);
  }

  public get(): Observable<KalturaConversionProfile[]> {
    if (!this._transcodingProfileCache$) {
      this._transcodingProfileCache$ = this._loadTranscodingProfiles()
        .catch((err) => {
          console.log(`log: [warn] [transcodingProfile-management] Error during load transcoding profiles: ${err}`);
          this._transcodingProfileCache$ = null;
          return Observable.throw(err);
        })
        .publishReplay(1)
        .refCount();
    }

    return this._transcodingProfileCache$;
  }
}
